import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';

import { Api } from '../../../../api';
import { AppState } from '../../../../store/models/app-state';

export const PRODUCT_DUPLICATE = 'PRODUCT_DUPLICATE';

export const duplicateProduct = (id: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: PRODUCT_DUPLICATE });

        const response = await api.product.duplicate(id);
        if (response.success) {
            dispatch(Snackbar.enqueue(Snackbar.PoolNotification.success('app.snackbar.articleDuplicated')));
            return response.result;
        } else {
            dispatch(Snackbar.enqueue(Snackbar.PoolNotification.error('app.snackbar.error')));
            return null;
        }
    };
};
